// export const getTimezoneInfo = () => {

//     const timezoneName = new Date().toLocaleDateString(undefined, {day:'2-digit',timeZoneName: 'long' }).substring(4).match(/\b(\w)/g).join('');
  
//     const date = new Date();
//     const timezoneOffset = -date.getTimezoneOffset();
//     const offsetHours = String(Math.floor(Math.abs(timezoneOffset / 60))).padStart(2, '0');
//     const offsetMinutes = String(Math.abs(timezoneOffset % 60)).padStart(2, '0');
//     const sign = timezoneOffset >= 0 ? '+' : '-';
//     const formattedOffset = `${sign}${offsetHours}:${offsetMinutes}`;
//     return { timezoneName, formattedOffset };
//   };

export const getTimezoneInfo = () => {
  const timeZone = 'Asia/Riyadh';
  const date = new Date();

  const timezoneName = new Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'long',
  }).formatToParts(date).find(part => part.type === 'timeZoneName').value;

  // Get offset in minutes from UTC for the given time zone
  const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone }));
  const timezoneOffset = (tzDate - utcDate) / 60000;

  const offsetHours = String(Math.floor(Math.abs(timezoneOffset / 60))).padStart(2, '0');
  const offsetMinutes = String(Math.abs(timezoneOffset % 60)).padStart(2, '0');
  const sign = timezoneOffset >= 0 ? '+' : '-';
  const formattedOffset = `${sign}${offsetHours}:${offsetMinutes}`;
  return { timezoneName, formattedOffset };
};
  